<template>
  <div class="panel-container">
    <MysticAltar
      :querentName="querentName"
      :querentSubscribed="querentSubscribed"
      :altarImageUrl="altarImageUrl"
      :homeSignal="homeSignal"
      :questTarget="questTarget"
      :initialTab="initialTab"
      :initialDay="initialDay"
      :tabs="tabs"
      :landTab="landTab"
      @close="$emit('close')"
      @updateQuerentName="$emit('updateQuerentName', $event)"
      @triggerAstrology="$emit('triggerAstrology')"
      @tabChange="$emit('tabChange', $event)"
      @dayChange="$emit('dayChange', $event)"
    />
  </div>
</template>

<script setup>
import MysticAltar from '@/pages/MysticAltar.vue'

defineProps({
  querentName: String,
  querentSubscribed: Boolean,
  altarImageUrl: { type: String, default: null },
  homeSignal: { type: Number, default: 0 },
  questTarget: { type: Object, default: null },
  initialTab: { type: String, default: '' },
  initialDay: { type: String, default: '' },
  tabs: { type: Array, default: () => ['altar', 'mirror', 'history'] },
  landTab: { type: String, default: '' },
})

defineEmits(['close', 'updateQuerentName', 'triggerAstrology', 'tabChange', 'dayChange'])
</script>

<style scoped>
.panel-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background: #08000f;
  box-sizing: border-box;
}
</style>
